import { createContext, useContext } from 'react'

type MarkModificationsContextType<Item = unknown> = {
  parentData?: Item
  activated?: boolean
}

export const MarkModificationsContext =
  createContext<MarkModificationsContextType>({ activated: false })

export function MarkModificationsProvider<Item>({
  children,
  ...values
}: React.PropsWithChildren<MarkModificationsContextType<Item>>) {
  return (
    <MarkModificationsContext.Provider value={values}>
      {children}
    </MarkModificationsContext.Provider>
  )
}

export const useMarkModifications = () => useContext(MarkModificationsContext)
